import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Dimensions, StyleSheet, View } from 'react-native';
import {
  MAP_SAFE_ZONE_BOTTOM_MARGIN,
  MAP_SAFE_ZONE_SIDE_MARGIN,
  MAP_SAFE_ZONE_TOP_MARGIN,
} from './constants';

export const DebugOverlay: React.FC = () => {
  const [styles] = useStyles();
  const { height, width } = Dimensions.get('window');

  // The “safe zone” is basically the leftover space in the middle
  // after subtracting top, bottom, and side margins
  const boxWidth = width - MAP_SAFE_ZONE_SIDE_MARGIN * 2;
  const boxHeight =
    height - MAP_SAFE_ZONE_TOP_MARGIN - MAP_SAFE_ZONE_BOTTOM_MARGIN;

  return (
    <View style={styles.debugContainer}>
      <View
        style={[
          styles.debugBox,
          {
            height: boxHeight,
            width: boxWidth,
          },
        ]}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  debugBox: {
    borderColor: theme.colors.primary,
    borderWidth: 2,
    left: MAP_SAFE_ZONE_SIDE_MARGIN,
    position: 'absolute',
    top: MAP_SAFE_ZONE_TOP_MARGIN,
  },
  debugContainer: {
    ...StyleSheet.absoluteFillObject,
    pointerEvents: 'none',
  },
}));
